import type { SpaceHours } from '@cocoonspace/sdk-js/types/spaceHours'
import { getFormattedTime } from '@cocoonspace/shared/utils/get-formatted-time'

import type { Locale } from '~/i18n/routing'

export interface OpeningHour {
	dayStart: string
	dayEnd: string
	open?: { from: string; to: string }[]
	closed?: boolean
}

const formatHourLabel = (time: string | number, locale: Locale) => {
	const formattedTime = getFormattedTime(time)

	return locale === 'fr'
		? formattedTime.replace(/^0/, '').replace(':', 'h')
		: formattedTime.replace(/^0/, '')
}

export const getConcatDaysHours = (
	hours: SpaceHours | undefined,
	locale: Locale,
) => {
	if (!hours) return []

	const { bank_holidays: _, ...days } = hours

	let currentStartEnd = {}
	const openingHours: OpeningHour[] = []

	// Ensure consistent ordering of days
	const orderedDays = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']

	const sortedEntries = orderedDays
		.filter((day) => day in days)
		.map((day) => [day, days[day as keyof typeof days]])

	sortedEntries.forEach(([day, row]) => {
		if (currentStartEnd === JSON.stringify(row)) {
			openingHours[openingHours.length - 1].dayEnd = day as string
		} else {
			currentStartEnd = JSON.stringify(row)

			const { closed, open } = row as {
				closed?: boolean
				open?: { from: string | number; to: string | number }[]
			}

			openingHours.push({
				closed,
				dayEnd: day as string,
				dayStart: day as string,
				open: open?.flatMap((time) => {
					if (
						time.from === undefined ||
						time.from === '' ||
						time.to === undefined ||
						time.to === ''
					) {
						return []
					}

					return [
						{
							from: formatHourLabel(time.from, locale),
							to: formatHourLabel(time.to, locale),
						},
					]
				}),
			})
		}
	})

	return openingHours
}
